import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

const SELF_CLOSING_TAGS = new Set([
	'area',
	'base',
	'br',
	'col',
	'embed',
	'hr',
	'img',
	'input',
	'link',
	'meta',
	'source',
	'track',
	'wbr',
]);

const TAG_REGEX = /<\/?(\w+)(?:\s[^>]*)?\/?\s*>/g;

function validateHtmlTags(text: string): string[] {
	const stack: string[] = [];
	const errors: string[] = [];
	let match: RegExpExecArray | null;

	while ((match = TAG_REGEX.exec(text)) !== null) {
		const fullMatch = match[0];
		const name = match[1].toLowerCase();

		if (fullMatch.startsWith('</')) {
			if (stack.length === 0) {
				errors.push(`nadmiarowy </${name}>`);
			} else {
				const expected = stack.pop();
				if (expected !== name) {
					errors.push(`oczekiwano </${expected}>, znaleziono </${name}>`);
				}
			}
		} else if (fullMatch.endsWith('/>') || SELF_CLOSING_TAGS.has(name)) {
			continue;
		} else {
			stack.push(name);
		}
	}

	if (stack.length > 0) {
		const unclosed = [...new Set(stack)];
		errors.push(`niezamknięte tagi: ${unclosed.map((t) => `<${t}>`).join(', ')}`);
	}

	return errors;
}

export function htmlTagsValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		if (typeof control.value !== 'string') {
			return null;
		}

		const masked = control.value.replace(/\{\{[^}]*\}\}/g, ' ');
		if (!/<[^>]+>/.test(masked)) {
			return null;
		}

		const errors = validateHtmlTags(masked);
		return errors.length > 0 ? { invalidHtmlTags: { invalid: errors } } : null;
	};
}
